import { useEffect, useRef } from "react";

// Module-level stack so all dialogs share the same ordering regardless of
// where they sit in the React tree. Each mounted DialogContent pushes a unique
// symbol; unmount removes it. On Escape, any dialog that isn't the topmost
// entry calls e.preventDefault() so only the most-recently-opened dialog closes.
const stack: symbol[] = [];

export function useDialogStack() {
	const idRef = useRef<symbol | null>(null);
	if (idRef.current === null) {
		idRef.current = Symbol();
	}

	useEffect(() => {
		const id = idRef.current as symbol;
		stack.push(id);
		return () => {
			const idx = stack.lastIndexOf(id);
			if (idx !== -1) stack.splice(idx, 1);
		};
	}, []);

	return {
		isTopDialog: () => stack[stack.length - 1] === idRef.current,
	};
}
